"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactCustomScrollbars = require("react-custom-scrollbars");
var _MenuList = _interopRequireDefault(require("@mui/material/MenuList"));
var _MenuItem = _interopRequireDefault(require("@mui/material/MenuItem"));
var _withStyles = _interopRequireDefault(require("@mui/styles/withStyles"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = exports.styles = function styles(theme) {
  return {
    itemRoot: {
      '&:hover': {
        backgroundColor: theme.palette.hover
      }
    },
    itemSelected: {
      fontWeight: theme.typography.fontWeightMedium,
      backgroundColor: theme.palette.selected
    },
    itemCentered: {
      margin: 'auto'
    },
    currentDateItem: {
      color: "".concat(theme.palette.primary.main, " !important")
    }
  };
};
var ListPicker = /*#__PURE__*/function (_React$PureComponent) {
  function ListPicker() {
    var _this;
    (0, _classCallCheck2.default)(this, ListPicker);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ListPicker, [].concat(args));
    _this.scrollbars = void 0;
    _this.position = void 0;
    return _this;
  }
  (0, _inherits2.default)(ListPicker, _React$PureComponent);
  return (0, _createClass2.default)(ListPicker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.position && this.scrollbars) {
        this.scrollbars.scrollTop((this.position - 2) * 40);
      } else if (this.props.initAtMiddleScroll && this.scrollbars) {
        this.scrollbars.scrollTop((this.scrollbars.getScrollHeight() - this.scrollbars.getClientHeight()) / 2 + 20);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        classes = _this$props.classes,
        itemList = _this$props.itemList,
        onItemClick = _this$props.onItemClick,
        selectedItem = _this$props.selectedItem,
        type = _this$props.type;
      this.position = itemList.indexOf(selectedItem);
      var now = new Date();
      return /*#__PURE__*/_react.default.createElement(_reactCustomScrollbars.Scrollbars, {
        autoHide: true,
        ref: function ref(_ref) {
          _this2.scrollbars = _ref;
        }
      }, /*#__PURE__*/_react.default.createElement(_MenuList.default, null, itemList.map(function (item, index) {
        var labelClass = (0, _classnames.default)(classes.itemCentered, (0, _defineProperty2.default)({}, classes.currentDateItem, type === 'year' && now.getFullYear() === item || type === 'month' && now.getMonth() === index));
        return /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
          key: "item-".concat(item),
          classes: {
            root: classes.itemRoot,
            selected: classes.itemSelected
          },
          onClick: function onClick() {
            return onItemClick(item);
          },
          selected: item === selectedItem
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: labelClass
        }, item));
      })));
    }
  }]);
}(_react.default.PureComponent);
ListPicker.defaultProps = {
  initAtMiddleScroll: true
};
var _default = exports.default = (0, _withStyles.default)(styles, {
  name: 'HmuiListPicker'
})(ListPicker);